const firebaseConfig = {
    apiKey: "AIzaSyCcXSC23paxog6Ict-9Xa-dXqhnDG0Tg8c",
    authDomain: "new-project-1e778.firebaseapp.com",
    projectId: "new-project-1e778",
    storageBucket: "new-project-1e778.appspot.com",
    messagingSenderId: "175249952526",
    appId: "1:175249952526:web:424d3b634b7fdfbc31115f"
};

export default firebaseConfig